import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// material
import {
    Grid, FormControl, TextField, Card, CardContent, Table, Button, TableRow, TableCell, TableBody, Container, TableContainer, TablePagination
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
// components
import Page from '../../components/Page';
import { Delete, BorderColorOutlined } from "@mui/icons-material";
import Iconify from "../../components/Iconify";
import Scrollbar from '../../components/Scrollbar';
import { UserListHead } from '../../sections/@dashboard/user';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { ResetSubadminDeleteAction, ResetSubadminStatusAction, SubadminDeleteAction, SubadminListAction, SubadminStatusAction } from 'src/redux/actions/SubadminAction';
import moment from 'moment';
import "./Subadmin.css"
import { toast } from 'react-toastify';
import Loader from 'src/components/Loader';
import DeleteRecordModal from "./../../components/DeleteRecordModal/DeleteRecordModal"
import { ListNotificationAction } from 'src/redux/actions/NotificationAction';

export default function NotificationList() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [state, setState] = useState({})
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const isLoading = useSelector(state => state.notification.loading)
    const listNotifySelector = useSelector(state => state?.notification?.notify_list?.data?.data);
    const countNotifySelector = useSelector(state => state?.notification?.notify_list?.data?.total_count);

    const closeDeleteModal = () => setShowDeleteModal(false);


    useEffect(() => {
        dispatch(ListNotificationAction((page + 1), rowsPerPage, {}));
    }, [dispatch, page, rowsPerPage]);
   
    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleDelete = () => {
        //dispatch(SubadminDeleteAction(modalUserID))
    }

    return (
        <Page title="Subadmin">
            {isLoading ? <Loader /> : null}
            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Notification List"
                    links={[
                        { name: 'Dashboard', href: "/dashboard/app" },
                        { name: 'List' }
                    ]}
                    action={
                        <Button
                            variant="contained"
                            onClick={() =>
                                navigate(`/dashboard/notification/create`)
                            }
                        >
                            New Notification
                        </Button>
                    }
                />

                <Card>
                    <CardContent>
                        <Scrollbar>
                            <TableContainer sx={{ minWidth: 800 }}>
                                {/* <form autoComplete="off" onSubmit={onClickSubmit}>
                                    <Grid container spacing={2} style={{ marginBottom: 10, marginTop: 2 }}>
                                        <Grid item md={3}>
                                            <FormControl fullWidth>
                                                <TextField
                                                    type="text"
                                                    label="Name"
                                                    variant="outlined"
                                                    value={state.name}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={3}>
                                            <FormControl fullWidth>
                                                <TextField
                                                    type="number"
                                                    label="Phone"
                                                    variant="outlined"
                                                    value={state.phone}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={3}>
                                            <FormControl fullWidth>
                                                <TextField
                                                    type="email"
                                                    label="Email"
                                                    variant="outlined"
                                                    value={state.email}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={3} style={{ textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <div className='reset-filter'>
                                                <Button
                                                    size="large"
                                                    color="primary"
                                                    className='btn'
                                                    variant="contained"
                                                    type="submit"
                                                >
                                                    Search
                                                </Button>
                                            </div>

                                            <div className='reset-filter'>
                                                <Button
                                                    color="primary"
                                                    className='btn'
                                                >
                                                    Reset Filter
                                                </Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </form> */}
                                <Table>
                                    <UserListHead
                                        headLabel={[
                                            { id: 's.no', label: 'Sr no.', alignRight: false },
                                            { id: 'title', label: 'Title', alignRight: false },
                                            { id: 'body', label: 'Body', alignRight: false },
                                            { id: 'createdAt', label: 'createdAt Date', alignRight: false },
                                            
                                        ]}
                                    />
                                    <TableBody>
                                        {listNotifySelector && listNotifySelector.map((data, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell
                                                        component="th"
                                                        scope="row"
                                                    >
                                                        {page * rowsPerPage + (index + 1)}.
                                                    </TableCell>
                                                    <TableCell align="left"> {data.title} </TableCell>
                                                    <TableCell align="left">
                                                         {data.body}
                                                    </TableCell>
                                                    <TableCell>
                                                        {moment(data.createdAt).format('DD/MM/YYYY hh:mm:ss')}
                                                    </TableCell>
                                                   
                                                    
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Scrollbar>
                        <TablePagination
                            rowsPerPageOptions={[25, 50, 100, 150, 200]}
                            component="div"
                            count={countNotifySelector}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </CardContent>
                </Card>
            </Container>

            <DeleteRecordModal
                state={showDeleteModal}
                onHide={closeDeleteModal}
                handleSubmit={handleDelete}
            />
        </Page>
    );
}
